import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { DetailsActionContext } from "./DetailsActionContext";
import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";
import ConfigurationForm from "@main/configurations/components/ConfigurationForm";

function useDetailsAction(id: number, formDefaultValues: any = {}): any {

  const get = useGet();
  const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */

  const onSuccessUpdate = () => {
    showSuccessMessage("successfull_action");
    getFunction(id); // We pass the function to refresh the table on success
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);
  
  /** Edition element definition */
  const { element } = useContext(DetailsActionContext);

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();  

  const onSubmitFunction = () => formRef.current?.formElement.current.requestSubmit() //We pass the function for the submit of the modal

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: DetailsActionContext,
    action: 'edit',
    className: "configuration-form",
    formDefaultValues: formDefaultValues
  };

  const actionTemplate = (
    <ConfigurationForm formConfig={formConfig} />
  );

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    onSubmitFunction,
    actionTemplate,
  };
}

export default useDetailsAction;
